import Backbone from 'backbone';

var VivokidChallengeConsent = Backbone.Model.extend({
    url: function() {
        let url = '/vivokidchallenge-service/adHocChallenge/invite/' + this.inviteId + '/' + this.scope;

        if (this.isVivoKidTeamStepChallenge) {
            url = '/vivokidchallenge-service/teamChallenge/invite/' + this.inviteId + '/' + this.scope;
        }

        return url;
    },

    backend: 'gcapi',

    initialize: function(attributes, options) {
        // scope can be either 'accept' or 'decline';
        this.inviteId = attributes.inviteId;
        this.isVivoKidTeamStepChallenge = attributes.isVivoKidTeamStepChallenge;
        this.scope = attributes.scope;
        this.options = options;
    }
});

export default VivokidChallengeConsent;
